export const LICENSE_SUBJECTS = {
  enterprise: "/license/enterprise",
  archive: "/license/enterprise/archive",
  auditlog: "/license/enterprise/auditlog",
  illuminate: "/license/enterprise/illuminate",
  searchFilter: "/license/enterprise/search-filter",
  customization: "/license/enterprise/customization",
  views: "/license/enterprise/views",
  forwarder: "/license/enterprise/forwarder",
  report: "/license/enterprise/report",
  security: "/license/security",
  anomaly: "/license/anomaly"
};
export const LICENSE_TYPES = {
  "/license/enterprise": "Enterprise",
  "/license/enterprise/customization": "Enterprise (Customization)",
  "/license/enterprise/archive": "Enterprise (Archiving)",
  "/license/enterprise/auditlog": "Enterprise (Audit Log)",
  "/license/enterprise/illuminate": "Enterprise (Illuminate)",
  "/license/enterprise/report": "Enterprise (Reporting)",
  "/license/enterprise/search-filter": "Enterprise (Search Filter)",
  "/license/enterprise/views": "Enterprise (Views)",
  "/license/enterprise/forwarder": "Enterprise (Forwarder)",
  "/license/security": "Security",
  "/license/anomaly": "Anomaly Detection"
};
export const LICENSE_TYPE = {
  drawDown: "Draw-Down",
  dailyUsage: "Daily Usage",
  dailyUsageRaw: "Daily Usage Raw"
};
export const LICENSE_STATUS = {
  active: "ACTIVE",
  queued: "QUEUED",
  expired: "EXPIRED",
  inactive: "INACTIVE"
};
export const DRAWDOWN_PRODUCTS = {
  enterprise: "Enterprise",
  security: "Security",
  anomaly: "Anomaly",
  volume: "Volume"
};
export const DRAWDOWN_PRODUCTS_NAMES = {
  Enterprise: "Enterprise",
  Security: "Security",
  Anomaly: "Anomaly Detection",
  Volume: void 0
};
